import { render, staticRenderFns } from "./HomeGoodsList.vue?vue&type=template&id=93aaae5e&scoped=true"
import script from "./HomeGoodsList.vue?vue&type=script&lang=js"
export * from "./HomeGoodsList.vue?vue&type=script&lang=js"
import style0 from "./HomeGoodsList.vue?vue&type=style&index=0&id=93aaae5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93aaae5e",
  null
  
)

export default component.exports